import React, { useRef } from "react";

import { config } from "@app/config";

import { CardBackground } from "./components/card-background";
import { CardProvider } from "./components/card-provider";
import { CardForeground } from "./components/card-foreground";
import { CardWrapper } from "./components/card-wrapper";

export type Props = {
  config: typeof config;
  handle: string;
};

export function InlineMerchCard({ config, handle }: Props) {
  const handleRef = useRef(handle);

  return (
    <CardProvider handle={handleRef.current}>
      <CardWrapper>
        <CardForeground />
        <CardBackground />
      </CardWrapper>
    </CardProvider>
  );
}
